import { sendHttp } from '../assets/js/request'

const systemConfigApi = {
  // 获取角色列表
  getRoleList (params) {
    return sendHttp('get', `/system/role/list`, params)
  },
  // 获取角色的配置信息
  getRoleInfoById (params) {
    return sendHttp('get', '/system/role/getRoleById', params)
  },
  // 编辑角色
  editRole (params) {
    return sendHttp('post', '/system/role/edit', params)
  },
  // 新增角色
  addRole (params) {
    return sendHttp('post', '/system/role/add', params)
  },
  // 新增角色
  deleteRole (params) {
    return sendHttp('delete', `/system/role/remove/${params.id}`)
  },
  // 启用角色
  enableRole (params) {
    return sendHttp('post', `/system/role/enable/${params.roleId}`)
  },
  // 获取角色配置的菜单列表
  getMenuList (params) {
    return sendHttp('get', '/system/menu/list', params)
  },
  // 新增/编辑菜单
  saveMenu (params) {
    if (params.menuId) {
      return sendHttp('post', '/system/menu/edit', params)
    } else {
      return sendHttp('post', '/system/menu/add', params)
    }
  },
  // 删除菜单
  deleteMenu (params) {
    return sendHttp('delete', '/system/menu/remove', params)
  },
  // 获取所有角色的按钮列表
  getBtnList () {
    return sendHttp('get', '/system/role/resource/all')
  },
  // 获取医院和根节点
  getHospitalAndRoot () {
    return sendHttp('get', '/system/dept/hospitalAndRoot')
  },
  // 获取所有医院
  getHospitals () {
    return sendHttp('get', '/system/dept/hospitals')
  },
  // 修改时段
  editGlucosePeriod (params) {
    return sendHttp('post', '/system/sysGlucosePeriod/edit', params)
  },
  // 获取危急值配置
  getCrisisConfig (params) {
    return sendHttp('get', '/system/sysGlucoseCrisis/list', params)
  },
  // 修改危急值配置
  editCrisisConfig (params) {
    return sendHttp('post', '/system/sysGlucoseCrisis/edit', params)
  },
  // 获取可视化数据配置
  getStatisticConfig (params) {
    return sendHttp('get', '/system/dept/getStatisticConfig', params)
  },
  // 更改可视化科室配置
  editStatisticConfig (params) {
    return sendHttp('post', '/system/dept/statisticConfig', params)
  },
  // 查询操作日志数据
  getOperateLogData (params) {
    return sendHttp('get', '/system/operlog/list', params)
  }
}

export { systemConfigApi }



// WEBPACK FOOTER //
// ./src/apis/systemConfigApi.js